<div class="bg-gray-100">
    <div class="container mx-auto py-10">
        <div class="bg-white shadow-sm  rounded-lg p-6">
            <h1 class="text-3xl font-bold text-center mb-4">Checkout</h1>
            <h2 class="text-xl font-semibold text-center mb-6">Bill Summary</h2>
            <div class="overflow-x-auto">
                <table class="w-full text-left">
                    <thead>
                        <tr class="border-b">
                            <th class="py-2">Item</th>
                            <th class="py-2 text-right">Amount (INR)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b">
                            <td class="py-2">ITR Filing Service</td>
                            <td class="py-2 text-right">500</td>
                        </tr>
                        <tr class="border-b">
                            <td class="py-2">GST</td>
                            <td class="py-2 text-right">90</td>
                        </tr>
                        <tr>
                            <td class="py-2 font-semibold">Total</td>
                            <td class="py-2 font-semibold text-right">590</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-6 text-center">
                <button class="bg-[#2071A7] hover:bg-[#1a5d8a] text-white font-medium py-2 px-6 rounded"
                    (click)="payNow()">
                    Proceed to Payment
                </button>
            </div>
        </div>
    </div>
</div>